import { render, staticRenderFns } from "./ExpenseDetails.vue?vue&type=template&id=4ed7b800&scoped=true&"
import script from "./ExpenseDetails.vue?vue&type=script&lang=js&"
export * from "./ExpenseDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseDetails.vue?vue&type=style&index=0&id=4ed7b800&lang=scss&scoped=true&"
import style1 from "./ExpenseDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed7b800",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VApp,VBreadcrumbs,VBreadcrumbsItem,VBtn,VCard,VCardText,VCol,VContainer,VIcon,VList,VListItem,VListItemTitle,VMenu,VRow,VSimpleTable})
